import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, ref } from "vue";
import {} from "@/components/SelectionDialog/selectionTypes";
import { errorMessageAsString } from "@/utils/simple-error";
import SelectionDialog from "@/components/SelectionDialog/SelectionDialog.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BasicSelectionDialog',
    props: {
        detailsKey: { default: "" },
        getData: null,
        isEncoded: { type: Boolean, default: false },
        labelKey: { default: "id" },
        leafIcon: { default: "" },
        timeKey: { default: "update_time" },
        title: null
    },
    emits: ["onCancel", "onOk", "onUpload"],
    setup(__props, { emit }) {
        const props = __props;
        const errorMessage = ref("");
        const items = ref([]);
        const modalShow = ref(true);
        const optionsShow = ref(false);
        const showTime = ref(false);
        const fields = computed(() => {
            const fields = [{ key: "label" }];
            if (props.detailsKey) {
                fields.push({ key: "details" });
            }
            if (showTime.value) {
                fields.push({ key: "time" });
            }
            return fields;
        });
        async function load() {
            optionsShow.value = false;
            try {
                // TODO: Consider supporting pagination here
                // this could potentially load quite a lot of items
                const incoming = await props.getData();
                items.value = incoming.map((item) => {
                    const timeStamp = item[props.timeKey];
                    showTime.value = !!timeStamp;
                    return {
                        id: item.id,
                        label: item[props.labelKey] || null,
                        details: item[props.detailsKey] || null,
                        time: timeStamp || null,
                        isLeaf: true,
                        url: "",
                    };
                });
                optionsShow.value = true;
            }
            catch (err) {
                errorMessage.value = errorMessageAsString(err);
            }
        }
        onMounted(() => load());
        return { __sfc: true, props, emit, errorMessage, items, modalShow, optionsShow, showTime, fields, load, SelectionDialog };
    }
});
